import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { shift_pressed } from '../../keypress';
import { uid_splitpatch_faces } from '@frontend/ui_display';
import splitpatch_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/splitpatch.svg';
import { img } from '@phi/components';
import SplitpatchTooltip from './SplitpatchTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const SplitPatchIcon = splitpatch_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Split patches';
        },

        disabled() {
            return this.state.editing_reference_sketches
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_stl
                || this.state.selected_faces_count < 1
                || this.state.selected_faces_count > 6;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'free')
                this.subscriptions.show_view_only_modal();
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else
                return uid_splitpatch_faces(
                    uid_selected_faces.keys(),
                    shift_pressed(),
                    false,
                    false,
                );
        },

        onLongClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'free')
                this.subscriptions.show_view_only_modal();
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else
                return uid_splitpatch_faces(
                    uid_selected_faces.keys(),
                    true,
                    false,
                    false,
                );
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.state.tut_stage === 2,
            active: false,
            id: 'splitpatch-button',
            wrapperId: 'splitpatch-wrapper',
            tippy: 'bottom',
            long: true,
            onClick: this.onClick,
            onLongClick: this.onLongClick,
            help: 'splitpatch',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            label: () => 'Split',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(splitpatch_svg, this.alt),
            tooltip: SplitpatchTooltip,
        });
    },
});
